import { LoadingSpinner } from '@components/atoms';
import * as React from 'react';
import { DEFAULT_LOADING_MESSAGE } from '../../data-grid.constants';
import type { DataGridStrings } from '../../data-grid.type';
import { Overlay } from './index';

interface LoadingOverlayProps {
	strings?: DataGridStrings;
}

const DEFAULT_LOADING = 'Loading...';

export const LoadingOverlay: React.FC<LoadingOverlayProps> = ({ strings }) => {
	const loadingMessage = strings?.loadingMessage || DEFAULT_LOADING_MESSAGE;

	return (
		<Overlay>
			<LoadingSpinner />
			<span className="text-lg text-primary">{DEFAULT_LOADING}</span>
			<span className="text-sm text-tertiary">{loadingMessage}</span>
		</Overlay>
	);
};
